import { SPLIT_IO_FEATURE_FLAG_PAGE_PRICING, SPLIT_IO_FEATURE_FLAG_PAGE_PRICING_COOKIE } from 'constants/split';
import { useSplitTreatment } from './useSplitTreatment';

export const useShowVariantPagePricing = (): boolean => {
  const { treatmentStatus } = useSplitTreatment(
      SPLIT_IO_FEATURE_FLAG_PAGE_PRICING,
      SPLIT_IO_FEATURE_FLAG_PAGE_PRICING_COOKIE
    );

  return treatmentStatus;
};
